// phase1 からコピーする
// survey style default values
export const BreakPoint = {
  desktop: '512px',
  small: '321px',
};

export const Color = {
  black: '#333333',
  red: '#bf0000',
  gray: '#9c9c9c',
  white: '#ffffff',
  text: {
    black: '#333333',
    darkGray: '#4d4d4d',
    gray: '#828282',
    green: '#047205',
    white: '#ffffff',
  },
  border: {
    blue: '#009ae9',
    darkGray: '#828282',
    gray: '#b6b6b6',
    lightGray: '#dadada',
    ultraLightGray: '#ebebeb',
    green: '#047205',
    yellowGreen: '#c9db00',
    lightGreen: '#7fca51',
    red: '#f53a3a',
    darkRed: '#bf0000',
    orange: '#f59600',
    yellow: '#ffd633',
  },
  // permission colors
  permission: ['#F76B6A', '#F59500', '#FFCC00', '#B7D831', '#29C72A'],
};

export const Coordinates = {
  right: '10%',
};

export const Font = {
  default:
    '"Hiragino Sans","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3",Osaka,Meiryo,メイリオ,"MS PGothic","MS Pゴシック","Hiragino Sans GB","Noto Sans CJK JP","Helvetica Neue",HelveticaNeue,Helvetica,Roboto,Arial,"Arial Unicode MS",sans-serif',
};

export const FontSize = {
  medium: '16px',
  small: '14px',
  tiny: '12px',
  tinier: '10px',
  desktop: {
    medium: '16px',
    small: '14px',
    tiny: '12px',
    tinier: '10px',
  },
  smallDevice: {
    medium: '15px',
  },
};

export default {
  BreakPoint,
  Color,
  FontSize,
  Font,
  Coordinates,
};



// WEBPACK FOOTER //
// ./src/phase2/survey/asset/styles/index.js